import { useRevealOnScroll } from "../../hooks/useRevealOnScroll";

// Envuelve contenido y lo revela con un fade-in suave al entrar en el
// viewport. `delay` (en ms) permite escalonar la aparición de varios
// elementos (efecto stagger). `as` permite elegir la etiqueta semántica.
const Reveal = ({
  children,
  delay = 0,
  as: Etiqueta = "div",
  className = "",
  ...props
}) => {
  const { ref, visible } = useRevealOnScroll();

  return (
    <Etiqueta
      ref={ref}
      className={`reveal ${visible ? "reveal-visible" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
      {...props}
    >
      {children}
    </Etiqueta>
  );
};

export default Reveal;
